var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef, memo } from "react";

var SvgLogoFull = function SvgLogoFull(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1956_105179)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.396 0.046875H154.061V30.8744H299.396V0.046875ZM299.396 44.7173H154.061V75.5448H299.396V44.7173ZM154.061 89.3896H299.396V120.217H154.061V89.3896Z",
    fill: "#1965FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 120.048H31.8752V31.0726H134.331V0.0605469H0V120.048ZM47.0521 120.032H78.5478V75.3595H134.329V44.7166H47.0521V120.032Z",
    fill: "#1965FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1956_105179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 299.429,
    height: 121.143,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoFull);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDMwMCAxMjIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xOTU2XzEwNTE3OSkiPgo8cGF0aCBmaWxsUnVsZT0iZXZlbm9kZCIgY2xpcFJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOTkuMzk2IDAuMDQ2ODc1SDE1NC4wNjFWMzAuODc0NEgyOTkuMzk2VjAuMDQ2ODc1Wk0yOTkuMzk2IDQ0LjcxNzNIMTU0LjA2MVY3NS41NDQ4SDI5OS4zOTZWNDQuNzE3M1pNMTU0LjA2MSA4OS4zODk2SDI5OS4zOTZWMTIwLjIxN0gxNTQuMDYxVjg5LjM4OTZaIiBmaWxsPSIjMTk2NUZFIi8+CjxwYXRoIGZpbGxSdWxlPSJldmVub2RkIiBjbGlwUnVsZT0iZXZlbm9kZCIgZD0iTTAgMTIwLjA0OEgzMS44NzUyVjMxLjA3MjZIMTM0LjMzMVYwLjA2MDU0NjlIMFYxMjAuMDQ4Wk00Ny4wNTIxIDEyMC4wMzJINzguNTQ3OFY3NS4zNTk1SDEzNC4zMjlWNDQuNzE2Nkg0Ny4wNTIxVjEyMC4wMzJaIiBmaWxsPSIjMTk2NUZFIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTk1Nl8xMDUxNzkiPgo8cmVjdCB3aWR0aD0iMjk5LjQyOSIgaGVpZ2h0PSIxMjEuMTQzIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";